import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import { Translate } from "react-localize-redux";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import styled from "styled-components";
import { PASSWORD_RULES } from "../../utils/password_rules";

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0.5rem 0 0 0;
`;

const Item = styled.li`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.85rem;
  line-height: 1.6;
  color: ${(props) => (props.$met ? "#2e7d32" : "#6b6b6b")};
`;

/**
 * Renders the shared PASSWORD_RULES as a live checklist. It holds no rule of its own: the
 * predicates and their labels come from utils/password_rules, which the form validator reads
 * too, so the list a user is shown cannot disagree with the one that gates submission.
 *
 * Exported unconnected so the catalog can render it without a redux store; the default export
 * below is the connected one the app uses.
 */
export function PasswordRequirements({ password }) {
  const value = password || "";
  return (
    <List aria-label="password-requirements">
      {PASSWORD_RULES.map((r) => {
        const met = r.test(value);
        const Icon = met ? CheckCircleIcon : RadioButtonUncheckedIcon;
        return (
          <Item key={r.key} $met={met} data-testid={`password-rule-${r.key}`} data-met={met}>
            <Icon fontSize="small" />
            <Translate id={r.translationId} />
          </Item>
        );
      })}
    </List>
  );
}

PasswordRequirements.propTypes = {
  password: PropTypes.string,
};

const selector = formValueSelector("form");

export default connect((state) => ({
  password: selector(state, "password"),
}))(PasswordRequirements);
